import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
// import axiosInstance from '../../core/axiosInstance';
import { onChildAdded, onValue, ref } from 'firebase/database';
import { database } from '../../firebase';
import { useAppDispatch, useAppSelector } from '../../core/hooks';
import {
  openPage,
  selectPerview,
} from '../../features/previewedPage/previewPageSlice';
import {
  MediaContainer,
  PreviewContainer,
  Slider,
  TextContainer,
  ImgBC,
} from './Preview.Style';
import ImageGallery from 'react-image-gallery';
import { countVisitors } from './../../visitors-count/localstorage';
import axios from 'axios';
import { toast } from 'react-toastify';

const Preview = () => {
  useEffect(() => {
    axiosInstance
      .get('/check-expired')
      .then()
      .catch((err) => {
        if (err.response.status === 400 && !err.response.license) {
          toast.error(err.response.data.message, {
            position: toast.POSITION.TOP_CENTER,
            toastId: 'uniqueId',
          });
          window.location.replace(window.location.origin + '/expired');
        }
      });
  }, []);
  const announcementKey: string | null = localStorage.getItem('announcement-key');
  const navigate = useNavigate();

  const page = useAppSelector(selectPerview);
  const dispatch = useAppDispatch();
  const [selectedPage, setselectedPage] = useState<any>({});
  const { id } = useParams();

  const images = selectedPage.media?.map((image: any, i: number) => {
    return {
      original: process.env.REACT_APP_AWS_STORAGE +image.url,
      thumbnail: process.env.REACT_APP_AWS_STORAGE +image.url,
    };
  });

  const getVideolink = () => {
    let link = selectedPage?.media[0].url;
    let domain = link.split('.com')[0].split('//')[1];
    if (domain === 'vimeo') {
      var vimeoRegex = /(?:vimeo)\.com.*(?:videos|video|channels|)\/([\d]+)/i;
      var parsed = link.match(vimeoRegex);
      link = "https://player.vimeo.com/video/" + parsed[1];
    }
    else {
      var videoId = link.split("?v=")[1]?.split('&')[0]; //id
      if (videoId) {
        link = "https://www.youtube.com/embed/" + videoId;
      }

    }
    return link;
  };

  const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_DATABASE_URL,
  });
  axiosInstance.interceptors.request.use(function (config: any) {
    config.headers['viewer-token'] = announcementKey;
    return config;
  });

  const dbref = ref(database, '/newevent');

  const getCurrentevent = () => {
    if (id) {
      let subUrl =
        typeof parseInt(id) === 'number' && Math.round(parseInt(id)) === parseInt(id)
          ? '/dashboard/pages/'
          : '/pages/';
      axiosInstance
        .get(`${subUrl}${id}`)
        .then((res: any) => {
          countVisitors(res.data.data.id);
          const EVENT_ID = localStorage.getItem('EVENT_ID');

          if (EVENT_ID != res.data.data.id) {
            caches.keys().then((casheKeys) => {
              casheKeys.forEach((casheKey) => {
                if (casheKey == 'CASHE_EVENT_IMAGES') {
                  caches.delete(casheKey);
                }
              });
            });

            localStorage.setItem('EVENT_ID', res.data.data.id);
          }
          setselectedPage(res.data.data);
        })
        .catch((err) => {
          if (err.response.data.message === 'Invalid token') {
            localStorage.removeItem('announcement-key');
            window.location.reload();
          }
        });
    } else {
      setselectedPage(page.page);
    }
    return () => {
      dispatch(openPage({ page: {} }));
    };
  };
  useEffect(() => {
    onValue(dbref, async (snapshot) => {
      // request the new event images
      getCurrentevent();
    });
  }, []);

  return selectedPage.media?.length > 0 &&
    selectedPage.media[0]?.type_id === 1 &&
    selectedPage.media?.length > 0 ? (
    <Slider>
      <ImgBC src={selectedPage.background} alt="" />
      <div className="overlay" />
      <ImageGallery items={images} />
    </Slider>
  ) : (
    <PreviewContainer>
      <img src={selectedPage.background} alt="" />
      <div className="overlay">
        {selectedPage?.text && (
          <TextContainer>
            {selectedPage.text.template.path && (
              <img src={selectedPage.text.template.path} alt="" />
            )}
            <div
              className="header"
              dangerouslySetInnerHTML={{ __html: selectedPage.text?.title }}
            ></div>
            <div
              className="t-body"
              dangerouslySetInnerHTML={{ __html: selectedPage.text?.body }}
            ></div>
          </TextContainer>
        )}

        {
          selectedPage.media?.length === 1 && selectedPage.media[0]?.type_id === 2 && (
            <iframe
              title="video_frame"
              src={`${process.env.REACT_APP_AWS_STORAGE + selectedPage?.media[0].url}?loop=1&controls=1`}
              height="100%"
              width="100%"
              frameBorder={0}
              allow="autoplay; fullScreen"
              allowFullScreen
              style={{
                position: 'absolute',
                top: '0',
                left: '0',
                bottom: '0',
                right: '0',
                width: '100%',
                height: '100%',
                border: 'none',
                margin: '0',
                padding: '0',
                overflow: 'hidden',
                zIndex: 999,
              }}
            />
          )
        }

        {selectedPage.media?.length > 0 &&
          selectedPage.media[0]?.type_id === 1 &&
          selectedPage.media?.length === 1 && (
            <MediaContainer>
              <img
                src={process.env.REACT_APP_AWS_STORAGE+selectedPage.media[0]?.url}
                alt={selectedPage.media[0]?.name}
                width="100%"
              ></img>
            </MediaContainer>
          )}
      </div>
    </PreviewContainer>
  );
};

export default Preview;
